module.exports = __webpack_public_path__ + "background1.jpg?4d237ddb136a2aed8c621b312ad8e66f";